import React from "react";

import MainLayout from "components/MainLayout";
import MainList from "components/MainList";

import columns from "./columns";

const LoginHistoryList = () => (
  <MainLayout breadcrumbs={[{ name: "Historia logowań" }]}>
    <MainList
      columns={columns}
      query_name="login_histories"
      query_path="/login_histories"
      query_context="index"
    />
  </MainLayout>
);
export default LoginHistoryList;
